'use client';

import { Button } from './Button';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  title: string;
  message: string | React.ReactNode;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({
  title,
  message,
  icon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-xl bg-white/80 p-4 text-center shadow-sm backdrop-blur-sm',
        'h-full min-h-[300px] w-full border border-gray-100/50',
        className
      )}
    >
      {icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-primary-50 to-primary-100 text-primary-600">
          {icon}
        </div>
      )}
      <h3 className="mb-2 text-xl font-semibold text-gray-900">{title}</h3>
      <div className="mb-6 max-w-md text-gray-500">
        {typeof message === 'string' ? <p>{message}</p> : message}
      </div>
      {action && <Button onClick={action.onClick}>{action.label}</Button>}
    </div>
  );
}
